import merge from 'lodash/merge'
import defaultTypography from '../typography'

export const FONTS = {
  REGULAR: '"Inter Regular", Helvetica, Arial, sans-serif',
  BOLD: '"Inter Bold", Helvetica, Arial, sans-serif',
  SEMI_BOLD: '"Inter SemiBold", Helvetica, Arial, sans-serif',
  TITLE: '"Code Next Heavy", Helvetica, Arial, sans-serif',
}

const BLICK_COLORS = {
  white: '#FFFFFF',
  black: '#111111',
  info: '#008BE3',
  success: '#62A01A',
  error: '#C6423F',
  warning: '#FFAC5A',
  red: '#E20000',
  redDark: '#A70000',
  grey100: '#F8F8F8',
  grey200: '#EEEEEE',
  grey400: '#CDCDCD',
  grey700: '#838383',
  grey800: '#5C5C5C',
  ultraLight4: '#F7F7F7',
}
const blickTypography = merge({}, defaultTypography, {
  heading: {
    large: {
      fontFamily: FONTS.TITLE,
      color: BLICK_COLORS.black,
    },
    small: {
      fontFamily: FONTS.TITLE,
      color: BLICK_COLORS.black,
    },
    subheading: {
      fontFamily: FONTS.BOLD,
      color: BLICK_COLORS.black,
    },
  },
  copy: {
    title: {
      color: BLICK_COLORS.black,
      fontFamily: FONTS.BOLD,
    },
    body: {
      color: BLICK_COLORS.black,
      fontFamily: FONTS.REGULAR,
    },
    bodyBold: {
      color: BLICK_COLORS.black,
      fontFamily: FONTS.BOLD,
    },
    bodyFaint: {
      color: BLICK_COLORS.greyMedium,
      fontFamily: FONTS.REGULAR,
    },
    tiny: {
      color: BLICK_COLORS.black,
      fontFamily: FONTS.REGULAR,
    },
    tinyFaint: {
      color: BLICK_COLORS.greyMedium,
      fontFamily: FONTS.REGULAR,
    },
    tinyBold: {
      color: BLICK_COLORS.black,
      fontFamily: FONTS.BOLD,
    },
  },
  label: {
    color: BLICK_COLORS.black,
    fontFamily: FONTS.BOLD,
    fontWeight: 700,
  },
  optional: {
    color: BLICK_COLORS.grey800,
    fontFamily: FONTS.REGULAR,
  },
})

export {blickTypography as typography, BLICK_COLORS as COLORS}
